import { render, staticRenderFns } from "./AssetAuth.vue?vue&type=template&id=04a507a0&scoped=true"
import script from "./AssetAuth.vue?vue&type=script&lang=js"
export * from "./AssetAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a507a0",
  null
  
)

export default component.exports